const app = Voonto.getInstance();

const libPath = app.lookup('vocento.config.nibara').libPath;
if (libPath === undefined) {
    throw 'nibara libPath config is empty';
}

let
  cargaSticky = false,
  tamBody = 0,
  tamColC = Voonto.$('.mas-contenido-articulo').height();
;
export function recalBody () {
  const Logger = nibara.logger;
  if (typeof Voonto.$('.hueco-imagen-principal ').height() === 'number') {
    tamBody = Voonto.$('.hueco-imagen-principal ').height() + Voonto.$('.cuerpo-texto').height();
  } else {
    tamBody = Voonto.$('.cuerpo-texto').height();
  }
  Logger.info('[Sticky] recalBody tamBody: ' + tamBody + ' tamColC: ' + tamColC);
}

export function initSticky () {
    const Logger = nibara.logger;
    Logger.info('[Sticky] Function initSticky');
    recalBody();
    if (tamBody >= tamColC && !cargaSticky) {
        app.load(libPath + 'sticky-kit/sticky-kit.min.js').then(() => {
            Logger.info('[Sticky] initSticky');
            Voonto.$('[data-sticky-spacer]').each(function (i, e) {
                let spacer = Voonto.$(e).parent().data('spacer');
                if (typeof spacer !== 'undefined') {
                    Logger.info('[Sticky] spacer: .', spacer);
                    Voonto.$(e).stick_in_parent({
                        offset_top: 20,
                        spacer: '.' + spacer
                    });
                }
            });
            cargaSticky = true;
        });
    }
    Logger.info('[Sticky] CargaSticky', cargaSticky);
}

export function recalcSticky () {
    const Logger = nibara.logger;
    Logger.info('[Sticky] Function recalcSticky');
    recalBody();
    if (tamBody >= tamColC) {
        if (cargaSticky) {
            Logger.info('[Sticky] recalcSticky');
            Voonto.$('[data-sticky-spacer]').parent().attr('style','');
            Voonto.$(document.body).trigger('sticky_kit:recalc');
        } else {
            initSticky();
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/layout/sticky-kit.js